const subuserStatementsIT = {
    "view": {
        "table": {
            "title": "Elenco delle dichiarazioni del tuo subutente",
            "column": {
                "type": "Tipo",
                "year": "Anno",
                "month": "Mese",
                "issue_year": "Anno di emissione",
                "issue_month": "Mese di emissione",
                "description": "Descrizione",
                "amount": "Importo",
                "status": "Stato",
                "details": "Dettagli",
                "overview": "Panoramica",
                "action": "Azione"
            },
            "button": {
                "export_csv": "Esporta CSV",
                "download": "Scarica"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "label": {
                "statusOpen": "Aperto",
                "statusPaid": "Pagato",
                "typeLicensing": "Licenza",
                "typeRegular": "Regolare",
                "typeAudioMasteringServices": "Audio Mastering - Servizi",
                "typeVinylEarnings": "Guadagni da Vinile",
                "typeOffset": "Compensazione",
                "typeNotKnown": "Non conosciuto",
                "monthJanuary": "Gennaio",
                "monthFebruary": "Febbraio",
                "monthMarch": "Marzo",
                "monthApril": "Aprile",
                "monthMay": "Maggio",
                "monthJune": "Giugno",
                "monthJuly": "Luglio",
                "monthAugust": "Agosto",
                "monthSeptember": "Settembre",
                "monthOctober": "Ottobre",
                "monthNovember": "Novembre",
                "monthDecember": "Dicembre"
            },
            "dropdown": {
                "markAsPaid": "Segna come PAGATO",
                "markAsOpen": "Segna come APERTO",
                "action": "Azione"
            },
            "message": {
                "statementUnavailable": "Tutte le dichiarazioni emesse prima di gennaio 2023 sono disponibili come allegati ZIP nella tua email."
            }
        },
        "message": {
            "successMarkedOpen": "La dichiarazione del subutente è stata segnata come APERTA!",
            "successMarkedPaid": "La dichiarazione del subutente è stata segnata come PAGATA!",
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!"
        },
        "modal": {
            "markAsPaid": {
                "header": "Segna la dichiarazione come PAGATA",
                "body": "Sei sicuro di voler segnare la dichiarazione {{statementName}} come PAGATA?"
            },
            "markAsOpen": {
                "header": "Segna la dichiarazione come APERTA",
                "body": "Sei sicuro di voler segnare la dichiarazione {{statementName}} come APERTA?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Elenco delle tue dichiarazioni",
            "column": {
                "name": "Nome della dichiarazione",
                "type": "Tipo",
                "quarter": "Trimestre",
                "year": "Anno",
                "month": "Mese",
                "description": "Descrizione",
                "amount": "Importo",
                "status": "Stato",
                "overview": "Panoramica",
                "details": "Dettagli"
            },
            "button": {
                "download": "Scarica",
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "label": {
                "statusOpen": "Aperto",
                "statusPaid": "Pagato",
                "typeLicensing": "Licenza",
                "typeRegular": "Regolare",
                "typeAudioMasteringServices": "Audio Mastering - Servizi",
                "typeVinylEarnings": "Guadagni da Vinile",
                "typeOffset": "Compensazione",
                "typeNotKnown": "Non conosciuto",
                "quarterQ1": "Q1",
                "quarterQ2": "Q2",
                "quarterQ3": "Q3",
                "quarterQ4": "Q4",
                "monthJanuary": "Gennaio",
                "monthFebruary": "Febbraio",
                "monthMarch": "Marzo",
                "monthApril": "Aprile",
                "monthMay": "Maggio",
                "monthJune": "Giugno",
                "monthJuly": "Luglio",
                "monthAugust": "Agosto",
                "monthSeptember": "Settembre",
                "monthOctober": "Ottobre",
                "monthNovember": "Novembre",
                "monthDecember": "Dicembre"
            },
            "message": {
                "statementUnavailable": "Tutte le dichiarazioni emesse prima di gennaio 2023 sono state inviate via email al tuo account manager."
            }
        }
    }
};

export default subuserStatementsIT;